import { render, staticRenderFns } from "./ResolveOutbreak.vue?vue&type=template&id=52ce1f9d&"
import script from "./ResolveOutbreak.vue?vue&type=script&lang=js&"
export * from "./ResolveOutbreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports